/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BudgetConsumptionResource
 */
export interface BudgetConsumptionResource {
    /**
     * 
     * @type {number}
     * @memberof BudgetConsumptionResource
     */
    committed: number;
    /**
     * 
     * @type {number}
     * @memberof BudgetConsumptionResource
     */
    remaining: number;
    /**
     * 
     * @type {number}
     * @memberof BudgetConsumptionResource
     */
    percent: number;
}

/**
 * Check if a given object implements the BudgetConsumptionResource interface.
 */
export function instanceOfBudgetConsumptionResource(value: object): value is BudgetConsumptionResource {
    if (!('committed' in value) || value['committed'] === undefined) return false;
    if (!('remaining' in value) || value['remaining'] === undefined) return false;
    if (!('percent' in value) || value['percent'] === undefined) return false;
    return true;
}

export function BudgetConsumptionResourceFromJSON(json: any): BudgetConsumptionResource {
    return BudgetConsumptionResourceFromJSONTyped(json, false);
}

export function BudgetConsumptionResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): BudgetConsumptionResource {
    if (json == null) {
        return json;
    }
    return {
        
        'committed': json['committed'],
        'remaining': json['remaining'],
        'percent': json['percent'],
    };
}

export function BudgetConsumptionResourceToJSON(value?: BudgetConsumptionResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'committed': value['committed'],
        'remaining': value['remaining'],
        'percent': value['percent'],
    };
}

